export function SearchResultsListTitleSkeleton() {
  return (
    <h5 className="px-sm 744:px-2xl pb-2xs">
      <div className="inline-block rounded-full size-sm mr-3xs skeleton-grey"></div>
      <div className="inline-block rounded w-[130px] h-sm skeleton-grey"></div>
    </h5>
  )
}
